var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import Component from "vue-class-component";
import SvgIcon from "~/components/common/svg-icon.vue";
import WorkMenuItem from "~/components/workspace/work-menu-item.vue";
import { Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import { CaseCollectorService } from "~/services/business-service/case-collector.service";
import { Dependencies } from "../../core/decorator";
var WorkMenu = /** @class */ (function (_super) {
    __extends(WorkMenu, _super);
    function WorkMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menuList = [];
        return _this;
    }
    WorkMenu.prototype.onCurrentTopMenuChange = function (value) {
        if (!value)
            return;
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
        if (value.id === 3) {
            this.dynamicMenu();
        }
        else {
            this.updateMenuList();
        }
    };
    /**
     * 更新左侧菜单
     */
    WorkMenu.prototype.updateMenuList = function () {
        this.menuList = this.queryMenusByResource();
        this.activeMenu();
    };
    WorkMenu.prototype.activeMenu = function () {
        if (!this.menuList.length)
            return;
        var path = this.$route.path;
        var urls = this.menuList.reduce(function (a, b) {
            return a.concat(b.children.map(function (v) { return v.url; }));
        }, []);
        if (!urls.includes(path)) {
            this.$router.push(urls[0]);
        }
    };
    /**
     *  查询菜单来自资源数据
     */
    WorkMenu.prototype.queryMenusByResource = function () {
        var _this = this;
        var secondMenus = this.filterChildren(this.currentTopMenu.id);
        return secondMenus.map(function (menu) {
            menu.children = _this.filterChildren(menu.id);
            return menu;
        });
    };
    WorkMenu.prototype.filterChildren = function (parent) {
        return [].concat(this.menuResource.filter(function (x) { return x.parent === parent; }).sort(function (a, b) { return a.sort - b.sort; })).map(function (v) {
            return __assign({}, v);
        });
    };
    WorkMenu.prototype.queryDynamicMenu = function () {
        var _this = this;
        this.subscription = this.caseCollectorService.findPrincipal().subscribe(function (principals) {
            var _a;
            var menus = principals.map(function (principal, index) {
                var children = _this.filterChildren(311).map(function (item) {
                    item.parent = principal.id;
                    item.id = item.id + "-" + index;
                    item.url += "/" + principal.id;
                    return item;
                });
                return {
                    icon: "danweixinxi",
                    id: principal.id,
                    level: 2,
                    name: principal.name,
                    parent: 3,
                    sort: index + 100000,
                    url: "/collection-manage",
                    type: "DIRECTORY",
                    children: children,
                };
            });
            (_a = _this.menuList).push.apply(_a, menus);
        });
    };
    WorkMenu.prototype.dynamicMenu = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.menuList = this.queryMenusByResource();
                this.activeMenu();
                this.queryDynamicMenu();
                return [2 /*return*/];
            });
        });
    };
    /**
     * 选择菜单项
     * 生成缓存项
     */
    WorkMenu.prototype.selectMenuItem = function (path, pathArray) {
        var _this = this;
        // 防止重复点击
        if (this.$route.path === path) {
            return;
        }
        // 路径长度验证
        if (pathArray.length !== 2) {
            return;
        }
        this.$nextTick(function () {
            _this.$router.push(path);
        });
    };
    __decorate([
        State
    ], WorkMenu.prototype, "menuResource", void 0);
    __decorate([
        State
    ], WorkMenu.prototype, "menuCollapse", void 0);
    __decorate([
        State
    ], WorkMenu.prototype, "userToken", void 0);
    __decorate([
        State
    ], WorkMenu.prototype, "currentTopMenu", void 0);
    __decorate([
        Dependencies(CaseCollectorService)
    ], WorkMenu.prototype, "caseCollectorService", void 0);
    __decorate([
        Watch("currentTopMenu", { immediate: true })
    ], WorkMenu.prototype, "onCurrentTopMenuChange", null);
    WorkMenu = __decorate([
        Component({
            components: {
                WorkMenuItem: WorkMenuItem,
                SvgIcon: SvgIcon,
            },
        })
    ], WorkMenu);
    return WorkMenu;
}(Vue));
export default WorkMenu;
